import { render, staticRenderFns } from "./AttachPrintTemplate.vue?vue&type=template&id=8623eb70&scoped=true&"
import script from "./AttachPrintTemplate.vue?vue&type=script&lang=ts&"
export * from "./AttachPrintTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AttachPrintTemplate.vue?vue&type=style&index=0&id=8623eb70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8623eb70",
  null
  
)

export default component.exports